<template>
  <section class="flex flex-1 flex-col overflow-hidden p-1">
    <CountryToShimmer
      v-if="countries.isLoading.value || countries.isFetching.value"
    />

    <UiErrorCard
      v-else-if="countries.isError.value"
      class="m-2 px-2 py-4 text-center"
      @onReload="countries.refetch"
    />

    <ul v-else class="flex-1 space-y-1 overflow-auto">
      <li v-for="country in countriesByQuery" :key="country.id">
        <button
          type="button"
          class="flex w-full items-center justify-between rounded-xl px-4 py-3 text-left outline-none hover:bg-gray-75 focus:bg-gray-75 focus:outline-none active:bg-gray-75"
          :class="
            country.id === selectedCountryToId ? 'bg-gray-75' : 'text-gray-500'
          "
          @click="emit('onSelect', country)"
        >
          <span class="flex flex-1 items-center space-x-3">
            <CountryFlag
              :country-id="country.id"
              :country-name="country.name"
            />
            <strong>{{ country.name }}</strong>
          </span>
        </button>
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { toLower, includes, partition, flattenDeep } from 'lodash-es';

  import { UiErrorCard } from '@shared/ui';
  import { useCountryToQuery, CountryFlag } from '@entities/country-to';

  import type { Tourflow } from '@aviata/platform-types';
  import CountryToShimmer from './CountryToShimmer.vue';

  const props = defineProps<{
    query: string;
    townFromId?: number;
    selectedCountryToId?: number;
  }>();

  const emit = defineEmits<{
    onSelect: [country: Tourflow.CountryTo];
  }>();

  const countries = useCountryToQuery(computed(() => props.townFromId));

  const countriesByQuery = computed<Tourflow.CountryTo[]>(() =>
    flattenDeep(
      partition(countries.data.value, country =>
        includes(toLower(country.name), toLower(props.query)),
      ),
    ),
  );
</script>
